import { Directive, HostBinding, Input } from '@angular/core';
import { DataObject } from '../interfaces/data-objects';

@Directive({
  selector: '[ivEnabledForResiProjects]'
})
export class ivEnabledForResiProjectsDirective {

  @Input('ivEnabledForResiProjects') data: {
    editable: boolean,
    transaction?: DataObject
  };

  @HostBinding('class')
  get elementClass(): string {
    // If country is not AUS then returning empty string
    if (this.data?.transaction?.usercountry !== 'AUS') {
      return '';
    }
    // For Australia, apply the original logic
    if (!this.data.editable && this.data?.transaction?.transaction_type === 'resi') {
      return 'enabled-for-resi-projects enabled-for-resi-projects__non-editable';
    }
    return '';
  }

  constructor() {
  }

}
